export const DEFAULT_TAKE_PROFIT_GAIN_PERCENTAGE = '5.0000';
export const DEFAULT_STOP_LOSS_PERCENTAGE = '2.0000';
export const LIQUIDATION_PRICE_GAP_PERCENTAGE = 0.2;
export const MIN_MARGIN_REQUIREMENT = 40;
export const SAFE_MARGIN_REQUIREMENT = 45;
export const TRADES_PER_PAGE = 30;
